<template>
  <div class="footer_partners">
    <h2>Nos partenaires</h2>
    <div class="footer_items" itemscope itemtype="http://schema.org/Organization">
      <a itemprop="sponsor" href="https://sfdermato.org/" title="Site officiel">
      	<img alt="logo SFD" src="//cdn.sfdermato.org/img/logo/sfdermato.svg" width="200px" height="60px">
      </a>
      <a itemprop="sponsor" href="https://www.sfdermato.org/site/centre-de-preuves-en-dermatologie.html" title="Site officiel">
      	<img alt="logo CDP" src="//cdn.sfdermato.org/img/logo/centre-de-preuves-en-dermatologie.svg" width="133px" height="120px" >
      </a>
      <a itemprop="sponsor" href="https://cedef.org/" title="Site officiel">
      	<img alt="logo CEDEF" src="//cdn.sfdermato.org/img/logo/cedef.svg" width="137px" height="120px">
      </a>
      <a itemprop="sponsor" href="https://fffcedv.org/" title="Site officiel">
      	<img alt="logo FFFCEDV" src="//cdn.sfdermato.org/img/logo/fffcedv.svg" width="120px" height="120px">
      </a>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'v-footer',
    data: () => {
      return {
      }
    },
  }
</script>

<style lang="scss">
.footer_partners {
  padding: rem(45px) rem(100px) rem(60px);
  border-top: 1px solid color(border);

  h2 {color:color(dark);margin-bottom:1.5em}

  .footer_items {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
  }

  @include mq($from: LG) {
    padding: rem(45px) rem(250px) rem(60px);

    img {
	  max-height: rem(120px);
      max-width: rem(160px);
      padding:rem(10px);
      width: 100%;
    }

    .svg {
      max-width: rem(260px);
    }
  }

  @include mq($until: SM) {
    padding: rem(30px) rem(10px) rem(40px);

    .footer_items {flex-direction:column}

    .svg,
    img {
      width:auto;
      min-height:100px;
      padding:1rem
    }

  }

  @include mq($from: SM, $until: LG) {
    padding: rem(45px) rem(50px) rem(60px);

    img {
      max-height: rem(100px);
      max-width: rem(140px);
    }
  }

}

</style>
